import React, { useState, useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";

import Badge from "@mui/material/Badge";
import Loading from "components/Loading";
import PlacementExamAssignForm from "components/PlacementExam/PlacementExamAssignForm";
import PlacementExamForm from "components/PlacementExam/PlacementExamForm";
import color from "utils/constants/color";
import moment from "moment-timezone";
import styled from "styled-components";
import { Button, Card, Col, Input, Modal, Row, Dropdown, message, Spin, Select, Form } from "antd";
import { DeleteModal } from "components/Dialog";
import { usePlacementExamList } from "store/placement_exam/selectors";
import { handleDuplicatePlacementExam, handleDeletePlacementExam, handleUpdatePlacementExam } from "store/placement_exam/thunks";
import { usePlacementExamDraft } from "utils/methods/firebasePlacementExamDraft";
import { useHasPermission } from 'utils/permissions';
import SentryWrap from 'components/Sentry';

//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import {
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TextareaAutosize,

} from '@mui/material';
import { makeStyles } from '@mui/styles';


  //  -- Components ---------------------
  import { PlusOutlined, SettingOutlined } from "@ant-design/icons";


  //  -- Constants ----------------------
  import { filter, isEmpty } from "lodash";
  //  -- Thunks -------------------------
  import { Assignment } from '@mui/icons-material';
  import { handleListPlacementexam } from "store/placement_exam/thunks";
import { useAlert } from "components/UI/alertSakeBar/alertProvider";
import { updatePlacementExamList } from "store/placement_exam/actions";












  const BORDERCOLOR = [
    "rgb(200,109,152)",
    "rgb(146,158,227)",
    "rgb(80,233,200)",
    "rgb(238,206,151)",
  ];
  //  ----------------------------------------------------------------------------
  //  Styles
  //  ----------------------------------------------------------------------------
  
  const StableWrapper = styled.div`
    width: 100%;
    overflow-x: auto;
    //   @media (max-width: 992px) {
    //     padding:24px 0px;
    //   }
  `;
  const StableWrapperMain = styled.div``;
  
  const FilterContainer = styled.span`
    font-size: 17px;
    font-weight: 500;
    cursor: pointer;
  `;
  
  const TextAreaAuto = styled(TextareaAutosize)`
    height: 200px;
    max-height: 210px;
    width: 100%;
    border-radius: 2px;
    padding: 5px;
    overflow: hidden;
    border-color: rgb(0 0 0 / 32%);
    ::focus-visible {
      outline: #03989e 1px !important;
      border: 5px solid red !important;
    }
    ::focus {
      border-color: #03989e !important;
    }
  `;


  const useStyles = makeStyles((theme) => ({
    formControl: {
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: '4px',
    },
  }));
  
  const PlacementExamList = ({ userloading }) => {
    const [filteredStanders, setFilteredPlacementExams] = useState([]);
    const [draftList, setDraftList] = useState([]);
    const dispatch = useDispatch();
    const placementExamList = usePlacementExamList();
    const { fetchPlacementExamDraftsWhereIsCreated, deletePlacementExamDraft } = usePlacementExamDraft();
    
    const hasViewPlacementExam = useHasPermission('placement_exam.view');
    const hasAddPlacementExam = useHasPermission('placement_exam.add');
    const hasEditPlacementExam = useHasPermission('placement_exam.edit');
    const hasDuplicatePlacementExam = useHasPermission('placement_exam.duplicate');
    const hasDeletePlacementExam = useHasPermission('placement_exam.delete');
    const hasAssignmentManagement = useHasPermission('placement_exam.assignment_management');
    
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [page, setPage] = React.useState(0);
    const [deleteToggle, setDeleteToggle] = useState(false);
    const [ loading , setLoader] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [openAssignForm, setOpenAssignForm] = useState(false);
    const [selectedAssignments, setSelectedAssignments] = useState({});
    const [duplicateModalVisible, setDuplicateModalVisible] = useState(false);
    const [duplicateLoading, setDuplicateLoading] = useState(false);
    const [duplicateForm] = Form.useForm();
    const showAlert = useAlert();
    const [archiveLoading, setArchiveLoading] = useState(false);
    
  
    useEffect(() => {
      const loadDrafts = async () => {
        if(showForm || openAssignForm) return;
        const drafts = await fetchPlacementExamDraftsWhereIsCreated(true);
        setDraftList(drafts || []);
      };
      loadDrafts();
    }, [showForm, openAssignForm]);

    const mergedList = useMemo(
      () => [...(draftList || []), ...(placementExamList || [])].filter((x) => !x.is_archived),
      [draftList, placementExamList]
    );

    useEffect(() => {
      setFilteredPlacementExams(mergedList);
    }, [mergedList]);
  
    const onSearch = (event) => {
      if (event.target.value && event.target.value.length >= 1) {
        const search = event.target.value;
        const filtered = filter(mergedList, (x) =>
          `${x.displayName || ''}`.toLowerCase().includes(search.toLowerCase())
        );
        setFilteredPlacementExams(filtered);
      } else {
        setFilteredPlacementExams(mergedList);
      }
    };
  
    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
    };
    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };

    const onDeleteItem = async () => {
      setLoader(true);
      try {
        if (selectedAssignments?.isDraft) {
          await deletePlacementExamDraft(selectedAssignments.docId);
          message.success('Draft deleted successfully');
          setDeleteToggle(false);
          setSelectedAssignments({});
          const drafts = await fetchPlacementExamDraftsWhereIsCreated(true);
          setDraftList(drafts || []);
          return;
        }
        const result = await dispatch(handleDeletePlacementExam(selectedAssignments.id));
        if (result && result.success) {
          message.success('Exam deleted successfully');
          setDeleteToggle(false);
          setSelectedAssignments({});
          await dispatch(handleListPlacementexam());
        } else {
          message.error(result?.message || 'Failed to delete exam');
        }
      } catch (error) {
        message.error(selectedAssignments?.isDraft ? 'Failed to delete draft' : 'Something went wrong while deleting exam');
      } finally {
        setLoader(false);
      }
    };

    const handleDuplicate = async (values) => {
      setDuplicateLoading(true);
      try {
        const result = await dispatch(handleDuplicatePlacementExam({
          id: selectedAssignments.id,
          displayName: values.displayName
        }));
        
        if (result && result.success) {
          message.success('Exam duplicated successfully');
          setDuplicateModalVisible(false);
          duplicateForm.resetFields();
          setSelectedAssignments({});
          await dispatch(handleListPlacementexam());
        } else {
          message.error(result?.message || 'Failed to duplicate exam');
        }
      } catch (error) {
        message.error('Something went wrong while duplicating exam');
      } finally {
        setDuplicateLoading(false);
      }
    };

    const handleMenuClick = (key, row) => {
      if (key === 'edit') {
        if (!hasEditPlacementExam) {
          message.warning('You do not have permission to access this feature.');
          return;
        }
        setShowForm(true);
        setSelectedAssignments(row);
      } else if (key === 'duplicate') {
        if (!hasDuplicatePlacementExam) {
          message.warning('You do not have permission to access this feature.');
          return;
        }
        setSelectedAssignments(row);
        duplicateForm.setFieldsValue({
          displayName: `${row.displayName} (Copy)`
        });
        setDuplicateModalVisible(true);
      } else if (key === 'delete') {
        if (row?.isDraft) {
          setSelectedAssignments(row);
          setDeleteToggle(true);
          return;
        }
        if (!hasDeletePlacementExam) {
          message.warning('You do not have permission to access this feature.');
          return;
        }
        setSelectedAssignments(row);
        setDeleteToggle(true);
      }
    };


    const archiveHandler = async (row) => {
      setArchiveLoading(row?.id);
      try{
        const result = await dispatch(handleUpdatePlacementExam({
          ...row,
          is_archived: row.is_archived ? false : true,
        }))
        if (result && result.success) {
          message.success(row.is_archived ? 'Exam unarchived successfully' : 'Exam archived successfully');
          await dispatch(updatePlacementExamList(result.data));
        } else {
          message.error(result?.message || 'Failed to archive exam');
        }
      }catch(error){
        console.log(error, 'error');
      }finally{
        setArchiveLoading("");
      }
    }

    return (
      <SentryWrap>
        <StableWrapperMain>
          <Row style={{ marginBottom: 15 }}>
            <Col>
              <Button
                onClick={() => {
                  if (!hasAddPlacementExam) {
                    message.warning('You do not have permission to access this feature.');
                    return;
                  }
                  setShowForm(true)
                  setSelectedAssignments({})
                }}
                style={{ minHeight: 38 }}
                type="primary"
              >
                <PlusOutlined /> Add placement exam
              </Button>
            </Col>
          </Row>
          <FilterContainer className="FilterHeading">
            <Card type="inner" title="Filters">
              <Row>
                <Col xs={24} lg={24} md={24} className="ColCardPadding">
                  <Card style={{ width: "100%" }}>
                    <Input
                      placeholder="Search by name"
                      bordered={false}
                      style={{ height: "32px" }}
                      onChange={onSearch}
                    />
                  </Card>
                </Col>
              </Row>
            </Card>
          </FilterContainer>
          <StableWrapper>
            <Table
              stickyHeader
              aria-label="sticky table"
              style={{
                width: "100%",
                textAlign: "center",
                backgroundColor: "#fff",
                marginTop: 20,
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell
                    style={{ textAlign: "left", fontSize: 16, fontWeight: "600" }}
                  >
                    Display name
                  </TableCell>
                  <TableCell
                    style={{ textAlign: "left", fontSize: 16, fontWeight: "600" }}
                  >
                     Duration
                  </TableCell>
                  <TableCell
                    style={{ textAlign: "left", fontSize: 16, fontWeight: "600" }}
                  >
                   Created at
                  </TableCell>
                  <TableCell
                    style={{ textAlign: "left", fontSize: 16, fontWeight: "600" }}
                  >
                    Edit
                  </TableCell>
                  <TableCell
                    style={{ textAlign: "left", fontSize: 16, fontWeight: "600" }}
                  >
                   Assign to
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {isEmpty(filteredStanders) &&
                  (userloading ? (
                    <Loading size={30} />
                  ) : (
                    <TableRow key={"0"} style={{ border: 0 }}>
                      <TableCell colSpan={5} style={{ textAlign: "center" }}>
                        No results
                      </TableCell>
                    </TableRow>
                  ))}
                {!isEmpty(filteredStanders) &&
                  filteredStanders
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => {
                      return (
                        <TableRow
                          key={row.id}
                          style={{
                            "&:lastChild td, &:lastChild th": { border: 0 },
                          }}
                         
                        >
                          <TableCell>
                            {" "}
                            {row&&row.displayName?row.displayName:'-'} {row?.isDraft ? ' (Draft)' : ''}
                          </TableCell>
                          <TableCell
                            style={{
                              textAlign: "left",
                              color: BORDERCOLOR[0],
                            }}
                          
                          >
                           {row&&row.duration>0?`${row.duration} minutes`:'-'}
                          </TableCell>
                          <TableCell
                            style={{
                              textAlign: "left",
                              color: BORDERCOLOR[0],
                              maxWidth: 380,
                            }}
                          >
                            {row?.isDraft && row?.updatedAt
                              ? moment(row.updatedAt).format('YYYY-MM-DD')
                              : row?.created_on
                              ? moment(row.created_on).format('YYYY-MM-DD')
                              : '-'}
                          </TableCell>
                          <TableCell
                            style={{
                              textAlign: "left",
                              color: "black",
                              cursor: "pointer",
                              maxWidth: 380,
                            }}
                          >
                            <Dropdown
                              menu={{
                                items: [
                                  { key: 'edit', label: 'Edit' },
                                  ...(row?.isDraft ? [] : [{ key: 'duplicate', label: 'Duplicate' }]),
                                  ...(row?.isDraft ? [{ key: 'delete', label: 'Delete draft', danger: true }] : row?.no_of_assigned == 0 ? [{ key: 'delete', label: 'Delete', danger: true }] : []),
                                ],
                                onClick: ({ key }) => handleMenuClick(key, row),
                              }}
                              trigger={['click']}
                              placement="bottomLeft"
                            >
                              <SettingOutlined 
                                style={{ 
                                  fontSize: 18, 
                                  cursor: 'pointer',
                                  color: '#1890ff'
                                }} 
                              />
                            </Dropdown>
                          </TableCell>
                          <TableCell
                            style={{
                              textAlign: "left",
                              maxWidth: 380,
                              cursor: row?.isDraft ? 'not-allowed' : 'pointer',
                              opacity: row?.isDraft ? 0.5 : 1,
                            }}
                            onClick={() => {
                              if (row?.isDraft) {
                                message.warning('Save the exam first to assign.');
                                return;
                              }
                              if (!hasAssignmentManagement) {
                                message.warning('You do not have permission to access this feature.');
                                return;
                              }
                              setSelectedAssignments(row);
                              setOpenAssignForm(true);
                            }}
                          >
                            <Badge badgeContent={row?.no_of_assigned ?? 0} color="secondary">
                              <Assignment color="primary" style={{ color: color.green100 }} />
                            </Badge>

                            <Button style={{ marginLeft: 18, width: 100 }} disabled={row?.isDraft} onClick={(e) => {e.stopPropagation(); archiveHandler(row)}}>
                              {row?.id === archiveLoading && <Loading size={16} white={false} />}
                              {row.is_archived ? 'Unarchive' : 'Archive'}
                            </Button>
                          </TableCell>
                        </TableRow>
                      );
                    })}
              </TableBody>
              <TableFooter>
                <TableRow>
                  {!isEmpty(filteredStanders) && (
                    <TablePagination
                      count={filteredStanders.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      rowsPerPageOptions={[10, 25, 50, 100]}
                      backIconButtonProps={{
                        color: "secondary",
                      }}
                      nextIconButtonProps={{ color: "secondary" }}
                    />
                  )}
                </TableRow>
              </TableFooter>
            </Table>
          </StableWrapper>
        </StableWrapperMain>
        <Modal
          footer={null}
          title={selectedAssignments.id ? `Edit Assignment` : `Create Assignment`}
          centered
          open={showForm}
          destroyOnHidden={true}
          onOk={() => setShowForm(false)}
          onCancel={() => { 
            showAlert('Data is saved as draft.', 'info');
            setShowForm(false)}}
          width={"100%"}
          height={"100%"}
          bodyStyle={{ padding:8}}
          className="FilterHeading"
        >
          <PlacementExamForm
             data={selectedAssignments||{}}
            onCreateOrUpdate={async ()=>{
              setShowForm(false)
              setSelectedAssignments({})
            }}
          />
        </Modal>
        <Modal
          footer={null}
          title={selectedAssignments.displayName||''}
          centered
          open={openAssignForm}
          destroyOnHidden={true}
          onOk={() => setOpenAssignForm(false)}
          onCancel={() => setOpenAssignForm(false)}
          width={"100%"}
          height={"100%"}
          bodyStyle={{ padding:8}}
          className="FilterHeading"
        >
          <PlacementExamAssignForm
             data={selectedAssignments||{}}
            onCreateOrUpdate={()=>{
              setOpenAssignForm(false)
              setSelectedAssignments({})
            }}
          />
        </Modal>
        <DeleteModal
          deleteToggle={deleteToggle}
          setDeleteToggle={setDeleteToggle}
          onDelete={onDeleteItem}
          message={`Are you sure you want to delete "${selectedAssignments.displayName || (selectedAssignments?.isDraft ? 'this draft' : 'this exam')}"?`}
          loading={loading}
        />
        <Modal
          title="Duplicate Placement Exam"
          open={duplicateModalVisible}
          onCancel={() => {
            setDuplicateModalVisible(false);
            duplicateForm.resetFields();
            setSelectedAssignments({});
          }}
          footer={null}
          centered
        >
          <Spin spinning={duplicateLoading}>
            <Form
              form={duplicateForm}
              layout="vertical"
              onFinish={handleDuplicate}
            >
              <Form.Item
                label="Display Name"
                name="displayName"
                rules={[
                  { required: true, message: 'Please enter display name' },
                  { min: 1, message: 'Display name must be at least 1 character' }
                ]}
              >
                <Input placeholder="Enter display name" />
              </Form.Item>
              <Form.Item style={{ marginBottom: 0, marginTop: 20 }}>
                <Row gutter={16} justify="end">
                  <Col>
                    <Button
                      onClick={() => {
                        setDuplicateModalVisible(false);
                        duplicateForm.resetFields();
                        setSelectedAssignments({});
                      }}
                    >
                      Cancel
                    </Button>
                  </Col>
                  <Col>
                    <Button type="primary" htmlType="submit" loading={duplicateLoading}>
                      Duplicate
                    </Button>
                  </Col>
                </Row>
              </Form.Item>
            </Form>
          </Spin>
        </Modal>
      </SentryWrap>
    );
  };
  
  
  export default PlacementExamList;